export default function Payments({color,fill}){
    return(
<svg width="22" height="18" viewBox="0 0 22 18" fill={fill} xmlns="http://www.w3.org/2000/svg">
<rect x="1" y="1" width="20" height="16" rx="5" stroke={color} strokeWidth="1.5"/>
<path d="M1 6.5H21" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M5 12.5H10" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

   )
}